import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useHistory } from "react-router-dom";
import { properties } from '../properties';
import $ from "jquery";

function LansaCookieParse() {
    let responseBody = useState([]);
    var json = Cookies.get('response-data');
    const history = useHistory();
    var responseTitle;
    try {
        json = atob(json);
        var jsonresponse = JSON.parse(json);
        let wpg_operation = jsonresponse.AOPERATION;
        responseTitle = properties.HTTP_RESPONSE_TITLE[jsonresponse.AOPERATION];
        var digest = "";
        for(var property in properties.md5_digest[wpg_operation]){
            if(jsonresponse["A"+properties.md5_digest[wpg_operation][property].slice(0,9).toUpperCase()]){
                digest+=jsonresponse["A"+properties.md5_digest[wpg_operation][property].slice(0,9).toUpperCase()];
            }
        }
        
        var fieldName;
        for (var outfield in properties.output_params[wpg_operation]) {
            var originalFieldName = properties.output_params[wpg_operation][outfield];

            // Use custom mapping if available, otherwise use truncated uppercase
            if (properties.DPA_FIELD_MAPPING && properties.DPA_FIELD_MAPPING[originalFieldName]) {
                fieldName = properties.DPA_FIELD_MAPPING[originalFieldName];
            } else {
                fieldName = "A" + originalFieldName.slice(0,9).toUpperCase();
            }
            
            responseBody.push(
                <div className="form-group" key={outfield}>
                    <div className="control-label ">
                        {fieldName}
                    </div>
                    <div className="col-sm-5">
                        <div className="response-form-control"> {jsonresponse[fieldName]} </div>
                    </div>
                </div>
            );
        }
        var md5 = require('md5');
        var security_check;
        if(md5(digest+properties.PASSWORD) === jsonresponse["ASECURITY"]){
            security_check = properties.SECURITY_CHECK_PASS;
        }
        else{
            security_check = properties.SECURITY_CHECK_FAIL;
        }
        responseBody.push(
            <>
                <div className="form-group" key="security">
                    <div className="control-label ">
                        ASECURITY
                    </div>
                    <div className="col-sm-5">
                        <div className="response-form-control"> {jsonresponse["ASECURITY"]} </div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label ">
                        Security Check
                    </div>
                    <div className="col-sm-5">
                        <div className="response-form-control"> {security_check} </div>
                    </div>
                </div>
            </>
        );
    }
    catch {
        responseTitle = "Parse Error"
        responseBody.push(
        <div className="form-group" >
            <div className="col-sm-5">
                <p className="response-form-control"> {jsonresponse} </p>
            </div>
        </div >);
    }

    if(!Cookies.get("response-data")){
        history.goBack();
    }

    function replaceHistory(){
        Cookies.remove("response-data");
        history.replace("/http");
    }

    useEffect(()=>{
        if(jsonresponse && document.getElementsByClassName(jsonresponse.operation)[0]){
            document.getElementsByClassName(jsonresponse.operation)[0].classList.add("active");
        }
        Cookies.remove("response-data");
        $(".page-body").scrollTop(0);
    },[jsonresponse])
    
    return (
        <div className="uioperation-response" >
            <h2>{responseTitle}</h2>
            {responseBody}
            <div className="form-group">
                <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary" onClick={replaceHistory}>Back</button>
                </div>
            </div>
        </div>
    );
}

export default LansaCookieParse;